define('plugin/static-page/model/StaticPageModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Static Page Model
     *
     * @class StaticPageModel
     */
    return BaseModel.extend({

        urlRoot: '/static-page/list/id/',

        defaults: {
            id: null,
            name: '',
            html: '',
        },

        initialize: function () {

            BaseModel.prototype.initialize.call(this, arguments);
        },

    });

});
